// extracted by mini-css-extract-plugin
module.exports = {"ContentArea__header":"ContentArea_ContentArea__header__nJHSJ","ContentArea__image":"ContentArea_ContentArea__image__84_vX","fadeInKeyframe":"ContentArea_fadeInKeyframe__O1pmd"};